import { UserInputAreaProps } from "types/userArea";
import { MODAL_CONTENT_TAB_INDEX, MODAL_INPUT_MAX_LENGTH } from "utils/constants";
import { FormField } from "components/common/FormField.component";
import { TextInput } from "components/common/TextInput.component";
import { useTranslation } from "components/translations/useTranslation";

const INPUT_ID = "workflows_user_comment_input";

export function UserInputArea(props: UserInputAreaProps) {
    const { translate } = useTranslation();

    return (
        <div className="w-100">
            {props.message && (
                <>
                    <div className="mb-4 text-default">
                        {props.message}
                    </div>
                    <br />
                </>
            )}
            <FormField
                id={INPUT_ID}
                label={props.inputMessage}
                labelState={`(${translate("popUp.required")})`}
                info={props.moreInfo ? { label: props.moreInfo } : undefined}
            >
                <TextInput
                    id={INPUT_ID}
                    ref={props.userInput}
                    defaultValue={props.defaultValue}
                    maxLength={MODAL_INPUT_MAX_LENGTH}
                    tabIndex={MODAL_CONTENT_TAB_INDEX}
                    onFocus={(e) => {
                        e.target.select();
                    }}
                />
            </FormField>
        </div>

    );
}
export default UserInputArea;
